export enum TipoLogradouroEnum {

  rua = "R.",
  avenida = "Av.",
  praca = "Pça.",
  alameda = "Al.",
  rodovia = "Rod.",
  travessa = "Trav.",
}
